import { render } from "./SprintList.vue?vue&type=template&id=0f0ce14c&ts=true"
import script from "./SprintList.vue?vue&type=script&lang=ts"
export * from "./SprintList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__